// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container {
    top: 0;
    z-index: 1;
    width: 100%;
    box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
    -webkit-backdrop-filter: blur(5px);
}

.Header {
    display: flex;
    align-items: center;
    height: 10vh;
    padding: 0rem 2rem;
    justify-content: space-between;
}

.header_left {
    display: flex;
    cursor: pointer;
    align-items: flex-end;
    gap: 0.5rem;
    justify-content: center;
}

.header_right {
    display: flex;
    gap: 3.5rem;
    justify-self: center;
    align-items: center;
}

.header_right_c1 {
    gap: 3.5rem;
    font-weight: 600;
    font-size: 1.1rem;
}


.active {
    color: var(--primary_color);
    border-bottom:1px solid var(--primary_color);
}
.header_right_c1>a:not(.active) {
&:hover{
    color: var(--hover_primary_color);
}
}

.name_avatar {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: var(--primary_color);
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

}
.name_avatar>p{
    position: absolute;
    top: 0rem;
    bottom: 0;
    color: var(--white);
    font-size: 1.4rem;
    font-weight: 600;
    text-align: center;
    text-justify: center;
    width: 100%;
}
.Modal_Avatar{
    position: absolute;
    right: 2rem;
    top:8vh;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    padding: 2rem 2rem 1rem 2rem;
    z-index: 10;
    background-color: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.Modal_Avatar::before{
    position: absolute;
    top: -.5rem;
    right: .8rem;
    content: "";
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ffffff; 
}
.Modal_Avatar>small{
    background-color: transparent !important;;
}
.cancelBtn, .cancelBtn>*{
    position: absolute;
    top: .2rem;
    right: .4rem;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
    color: rgb(95, 93, 93);
    font-size: 1.1rem;

}


.notification_icon {
    font-size: 24px;
}

.notification-count {
    position: absolute;
    top: 2%;
    background-color: red;
    color: white;
    font-size: 12px;
    border-radius: 50%;
    padding: 4px 6px;
    margin-left: -1px;
}

@media screen and (max-width: 1025px) {
    .header_right_c1 {
        display: none !important;
    }
    .Header {
        padding: 0rem 1rem;
        justify-content: space-between;
    }
    .Modal_Avatar{
        right: 0.8rem;
        top:8vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,UAAU;IACV,WAAW;IACX,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;AACA;AACA;IACI,iCAAiC;AACrC;AACA;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,gDAAgD;IAChD,4BAA4B;IAC5B,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,oCAAoC;IACpC,iCAAiC;AACrC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,+FAA+F;IAC/F,sBAAsB;IACtB,iBAAiB;;AAErB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,kBAAkB;QAClB,8BAA8B;IAClC;IACA;QACI,aAAa;QACb,OAAO;IACX;AACJ","sourcesContent":[".Header_container {\n    top: 0;\n    z-index: 1;\n    width: 100%;\n    box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;\n    -webkit-backdrop-filter: blur(5px);\n}\n\n.Header {\n    display: flex;\n    align-items: center;\n    height: 10vh;\n    padding: 0rem 2rem;\n    justify-content: space-between;\n}\n\n.header_left {\n    display: flex;\n    cursor: pointer;\n    align-items: flex-end;\n    gap: 0.5rem;\n    justify-content: center;\n}\n\n.header_right {\n    display: flex;\n    gap: 3.5rem;\n    justify-self: center;\n    align-items: center;\n}\n\n.header_right_c1 {\n    gap: 3.5rem;\n    font-weight: 600;\n    font-size: 1.1rem;\n}\n\n\n.active {\n    color: var(--primary_color);\n    border-bottom:1px solid var(--primary_color);\n}\n.header_right_c1>a:not(.active) {\n&:hover{\n    color: var(--hover_primary_color);\n}\n}\n\n.name_avatar {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    background-color: var(--primary_color);\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n.name_avatar>p{\n    position: absolute;\n    top: 0rem;\n    bottom: 0;\n    color: var(--white);\n    font-size: 1.4rem;\n    font-weight: 600;\n    text-align: center;\n    text-justify: center;\n    width: 100%;\n}\n.Modal_Avatar{\n    position: absolute;\n    right: 2rem;\n    top:8vh;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n    padding: 2rem 2rem 1rem 2rem;\n    z-index: 10;\n    background-color: white;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n.Modal_Avatar::before{\n    position: absolute;\n    top: -.5rem;\n    right: .8rem;\n    content: \"\";\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-bottom: 10px solid #ffffff; \n}\n.Modal_Avatar>small{\n    background-color: transparent !important;;\n}\n.cancelBtn, .cancelBtn>*{\n    position: absolute;\n    top: .2rem;\n    right: .4rem;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;\n    color: rgb(95, 93, 93);\n    font-size: 1.1rem;\n\n}\n\n\n.notification_icon {\n    font-size: 24px;\n}\n\n.notification-count {\n    position: absolute;\n    top: 2%;\n    background-color: red;\n    color: white;\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 4px 6px;\n    margin-left: -1px;\n}\n\n@media screen and (max-width: 1025px) {\n    .header_right_c1 {\n        display: none !important;\n    }\n    .Header {\n        padding: 0rem 1rem;\n        justify-content: space-between;\n    }\n    .Modal_Avatar{\n        right: 0.8rem;\n        top:8vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
